module.exports = __webpack_public_path__ + "static/img/aRZ_pic02.beb81aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aRZ_pic02.jpg
// module id = yxf5
// module chunks = 5